import gsap from "gsap";
import SplitText from "gsap/SplitText";


gsap.registerPlugin(SplitText) 

export default function() {
	function isMobile() {
		return window.innerWidth < 768;
	}

	function menuButtonAnimation(){
		const menuButton      = document.querySelector('[data-name="menu-button"]');
		const menuTextTop     = menuButton.querySelector('.top');
		const menuTextRegular = menuButton.querySelector('.regular');

		if ( ! menuButton ) return;

		let splitTop = new SplitText(menuTextTop, { type: "words, chars" });
		let splitRegular = new SplitText(menuTextRegular, { type: "words, chars" });

		const enterTimeline = gsap.timeline({ paused: true, defaults: { ease: 'power2.out' } });
		const leaveTimeline = gsap.timeline({ paused: true, defaults: { ease: 'power2.out' } });

		enterTimeline
			.to(menuTextTop, { y: 0, duration: 0.3 }, 0)
			.from(splitTop.chars, { y: -100, duration: 0.4, stagger: 0.03 }, 0)
			.to(menuTextRegular, { y: 30, duration: 0.3 }, 0)
			.to(splitRegular.chars, { y: 100, duration: 0.4, stagger: 0.03 }, 0);
		leaveTimeline
			.to(menuTextTop, { y: 0, duration: 0.3 }, 0)
			.to(menuTextRegular, { y: 30, duration: 0.3 }, 0)
			.to(splitRegular.chars, { y: 100, duration: 0.0, stagger: 0 }, 0);

		// Enter
		menuButton.parentElement.addEventListener('pointerenter', () => {
			if ( document.querySelector('body').classList.contains('site-menu-open') ) return;
			enterTimeline.restart();
		});

		// Leave
		menuButton.parentElement.addEventListener('pointerleave', () => {
			if (document.body.classList.contains('site-menu-open')) return;
			leaveTimeline.reverse();
		});
	}

	function siteMenuOpenClose(){
		const body             = document.querySelector('body');
		const trigger          = document.querySelector('[data-name="menu-button"]');
		const siteMenu         = document.querySelector('[data-name="site-menu"]');
		const siteMenuOverlay  = document.querySelector('[data-name="site-menu-overlay"]');
		const menuButton       = document.querySelector('[data-name="menu-button"]');
		const topNav           = document.querySelector('[data-name="top-nav"]');

		if ( ! trigger || ! siteMenu || ! siteMenuOverlay ) return;

		trigger.addEventListener('click', (event) => {
			event.preventDefault();
			body.classList.toggle('site-menu-open');

			if ( body.classList.contains('site-menu-open') ) {
				gsap.to( siteMenuOverlay, { autoAlpha: 1, pointerEvents: 'all', duration: 0.4 });
				gsap.set( topNav, { pointerEvents: 'all' } );
				gsap.to( siteMenu, { left: 0, duration: 0.5 });

				// Change the menu button text to say Close.
				menuButton.querySelector('.close').classList.remove('hidden');
				menuButton.querySelector('.top, .regular').classList.add('hidden');
			} else {
				gsap.to( siteMenuOverlay, { autoAlpha: 0, pointerEvents: 'none', duration: 0.4 });
				gsap.to( siteMenu, { left: '-100%', duration: 0.5 });

				// If not a the top (it's scrolled down)
				if ( window.scrollY > 0 ) {
					gsap.set( topNav, { pointerEvents: 'none' } );
				}

				// Change the menu button text back to Menu.
				menuButton.querySelector('.close').classList.add('hidden');
				menuButton.querySelector('.top, .regular').classList.remove('hidden');

				// Close any open submenus and open the current page's submenu (for the next time the menu is opened)
				setTimeout(() => {
					siteMenuCloseSubMenu( siteMenu.querySelector('.sub-menu-open > a') );
					currentPageOpen();
				}, 500);
			}
		});

		// Click on the siteMenuOverlay closes the menu
		siteMenuOverlay.addEventListener('click', (event) => {
			event.preventDefault();
			body.classList.remove('site-menu-open');
			gsap.to( siteMenuOverlay, { autoAlpha: 0, pointerEvents: 'none', duration: 0.4 });
			gsap.to( siteMenu, { left: '-100%', duration: 0.5 });

			// Change the menu button text back to Menu.
			menuButton.querySelector('.close').classList.add('hidden');
			menuButton.querySelector('.top, .regular').classList.remove('hidden');

			// Close any open submenus and open the current page's submenu (for the next time the menu is opened)
			setTimeout(() => {
				siteMenuCloseSubMenu( siteMenu.querySelector('.sub-menu-open > a') );
				currentPageOpen();
			}, 500);
		});
	}

	function siteMenuOpenSubMenu( submenuItem ){
		const siteMenu = document.querySelector('[data-name="site-menu"]');
		const allSubMenus = document.querySelectorAll('#main-menu .sub-menu-wrap');

		if ( ! allSubMenus ) return;

		allSubMenus.forEach(subMenu => {
			if ( subMenu !== submenuItem.nextElementSibling ) {
				subMenu.parentElement.classList.remove('sub-menu-open');

				if (  isMobile() ) {
					gsap.to( subMenu, { autoAlpha: 0, left: '-100%', duration: 0.5 });
				} else {
					gsap.to( subMenu, { autoAlpha: 0, duration: 0.01 });
					gsap.to( subMenu.querySelectorAll('.sub-menu > li'), { y: 150, duration: 0.01 });
					setTimeout(() => {
						gsap.set( subMenu, { marginLeft: '-50%' } )
					}, 500);
				}
			}
		});

		submenuItem.parentElement.classList.add('sub-menu-open');
		siteMenu.classList.add('has-sub-menu-open');

		if ( isMobile() ) {
			gsap.to( submenuItem.nextElementSibling, { autoAlpha: 1, left: 0, duration: 0.5 });
		} else {
			if ( submenuItem.nextElementSibling ){
				gsap.set( submenuItem.nextElementSibling, { marginLeft: '45%' } )
				gsap.to( submenuItem.nextElementSibling, { autoAlpha: 1, duration: 0.5 });
				gsap.to( submenuItem.nextElementSibling.querySelectorAll('.sub-menu > li'), { y: 0, duration: 0.5, stagger: 0.02 });
			}
		}
	}
	function siteMenuCloseSubMenu( submenuItem ){
		const siteMenu = document.querySelector('[data-name="site-menu"]');

		if ( ! submenuItem ) return;

		submenuItem.parentElement.classList.remove('sub-menu-open');
		siteMenu.classList.remove('has-sub-menu-open');

		if ( isMobile() ) {
			gsap.to( submenuItem.nextElementSibling, { autoAlpha: 0, left: '-100%', duration: 0.5 });
		} else {
			gsap.set( submenuItem.nextElementSibling, { marginLeft: '50%' } )
			gsap.to( submenuItem.nextElementSibling, { autoAlpha: 0, duration: 0.01 });
		}
	}
	function siteMenuOpenCloseSubMenu(){
		const parents = document.querySelectorAll('#main-menu > li.menu-item-has-children > a');

		if ( ! parents ) return;

		parents.forEach(parent => {
			parent.addEventListener('click', (event) => {
				event.preventDefault();

				parent.parentElement.classList.toggle('sub-menu-open');

				if ( parent.parentElement.classList.contains('sub-menu-open') ) {
					siteMenuOpenSubMenu( parent );
				} else {
					siteMenuCloseSubMenu( parent );
				}
			});
		});
	}
	function siteMenuSubMenuBackButton(){
		const backButtons = document.querySelectorAll('#main-menu .back-menu');

		if ( ! backButtons ) return;

		backButtons.forEach(button => {
			button.addEventListener('click', (event) => {
				event.preventDefault();
				siteMenuCloseSubMenu( button.closest('.sub-menu-wrap').previousElementSibling );
			});
		});
	}
	function currentPageOpen(){
		const currentPageAncestor = document.querySelector('li.current-page-ancestor');

		if ( ! currentPageAncestor ) return;

		siteMenuOpenSubMenu( currentPageAncestor.querySelector('a') );
	}


	function usefulLinksMenu() {
		const usefulLinksMenuTrigger = document.querySelector('[data-name="useful-links-menu-trigger"]');
		const usefulLinksMenu = document.querySelector('[data-name="useful-links-menu"]');
		const usefulLinksMenuOverlay  = document.querySelector('[data-name="useful-menu-overlay"]');

		if ( ! usefulLinksMenuTrigger ) return;

		gsap.set( usefulLinksMenu, { autoAlpha: 0, height: 0});

		usefulLinksMenuTrigger.addEventListener('click', (event) => {
			event.preventDefault();
			usefulLinksMenuTrigger.classList.toggle('open');

			if ( usefulLinksMenuTrigger.classList.contains('open') ) {
				gsap.to( usefulLinksMenu, { autoAlpha: 1, height: 'auto', duration: 0.5 });
				gsap.to( usefulLinksMenuOverlay, { autoAlpha: 1, pointerEvents: 'all', duration: 0.4 });
			} else {
				gsap.to( usefulLinksMenu, { autoAlpha: 0, height: 0, duration: 0.5 });
				gsap.to( usefulLinksMenuOverlay, { autoAlpha: 0, pointerEvents: 'none', duration: 0.4 });
			}
		});

		// Close it by clicking anywhere else on the page or scroll
		window.addEventListener('scroll', (event) => {
			if ( usefulLinksMenuTrigger.classList.contains('open') ) {
				usefulLinksMenuTrigger.classList.remove('open');
				gsap.to( usefulLinksMenu, { autoAlpha: 0, height: 0, duration: 0.5 });
				gsap.to( usefulLinksMenuOverlay, { autoAlpha: 0, pointerEvents: 'none', duration: 0.4 });
			}
		});
		document.addEventListener('click', (event) => {
			if ( ! event.target.closest('[data-name="useful-links-menu-trigger"]') ) {
				usefulLinksMenuTrigger.classList.remove('open');
				gsap.to( usefulLinksMenu, { autoAlpha: 0, height: 0, duration: 0.5 });
				gsap.to( usefulLinksMenuOverlay, { autoAlpha: 0, pointerEvents: 'none', duration: 0.4 });
			}
		});

		// MOBILE VERSION
		const usefulLinksMobileMenuTrigger = document.querySelector('[data-name="useful-links-mobile-menu-trigger"]');
		const usefulLinksMobileMenu = document.querySelector('[data-name="useful-links-mobile-menu"]');

		if ( usefulLinksMobileMenuTrigger ) {
			gsap.set( usefulLinksMobileMenu, { autoAlpha: 0, height: 0});
	
			usefulLinksMobileMenuTrigger.addEventListener('click', (event) => {
				event.preventDefault();
				usefulLinksMobileMenuTrigger.classList.toggle('open');
	
				if ( usefulLinksMobileMenuTrigger.classList.contains('open') ) {
					gsap.to( usefulLinksMobileMenu, { autoAlpha: 1, height: 'auto', duration: 0.5 });
					gsap.to( usefulLinksMobileMenuTrigger.querySelector('svg path:nth-child(3)'), { rotate: 90, transformOrigin: 'center', duration: 0.5 } );
				} else {
					gsap.to( usefulLinksMobileMenu, { autoAlpha: 0, height: 0, duration: 0.5 });
					gsap.to( usefulLinksMobileMenuTrigger.querySelector('svg path:nth-child(3)'), { rotate: 0, duration: 0.5 } );
				}
			});
		}

	}


	function fixMenuButton(){
		const topNav          = document.querySelector('[data-name="top-nav"]');
		const topNavLogo      = document.querySelector('[data-name="top-nav-logo"]');
		const usefulLinksMenu = document.querySelector('[data-name="useful-links-menu-trigger"]')?.parentElement;
		const menuButton      = document.querySelector('[data-name="menu-button"]');
		
		let scrollAmount = 1;

		if ( document.querySelector('body').classList.contains('page-template-home') ){
			scrollAmount = 100;
		}

		if ( ! usefulLinksMenu ) return;

		window.addEventListener('scroll', (event) => {
			if ( window.scrollY > scrollAmount ) {
				gsap.to( [usefulLinksMenu, topNavLogo], { autoAlpha: 0, pointerEvents: 'none', duration: 0.2 } );
				gsap.set( topNav, { pointerEvents: 'none' } );
				gsap.set( menuButton, { pointerEvents: 'all' } );
			} else {
				gsap.to( [usefulLinksMenu, topNavLogo], { autoAlpha: 1, pointerEvents: 'all', duration: 0.2 } );
				gsap.set( topNav, { pointerEvents: 'all' } );
			}
		});
	}

	menuButtonAnimation()
	siteMenuOpenClose()
	siteMenuOpenCloseSubMenu()
	siteMenuSubMenuBackButton()
	currentPageOpen()
	usefulLinksMenu()
	fixMenuButton()
}
